import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { speed } from 'src/ui/common/config/animations';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledFilterHeader = styled(FlexBox)<{ isActive: boolean }>`
    cursor: pointer;
    height: 46px;
    padding: 0 20px;
    border-bottom: 1px solid ${({ theme, isActive }) => (isActive ? theme.colors.blue500 : '#e6e6e6')};
    user-select: none;
    transition: border-color ${speed.content} ease-in-out;

    ${media.md`
    height: 56px;
  `}
`;

export const StyledFilterContent = styled.div<{ opened: boolean }>`
    max-height: ${({ opened }) => (opened ? 'auto' : '0')};
    overflow: hidden;

    & > div {
        padding: 20px;
    }

    label {
        margin-left: 20px;
    }
`;
